export default {
    rowHeight: 30,
    enableSorting: true,
    enableFilter: true,
    headerHeight: 34,
    rowSelection: 'single',
    columnDefs: [
        {
            field: 'title',
            headerName: 'Title',
            cellRenderer: 'cell',
            width: 340,
            minWidth: 140,
        },
        {
            field: 'category',
            headerName: 'Category',
            sort: 'desc',
            minWidth: 120,
            suppressFilter: true
        },
        {
            field: 'capacity',
            headerName: 'Capacity',
            //filter: 'agNumberColumnFilter',
            suppressFilter: true,
            width: 110,
            minWidth: 110,
            valueFormatter: (params) => {
                return params.value ? params.value + params.data.capacityMeasurement : '-'
            }
        },
        {
            field: 'widthMillimeters',
            headerName: 'W (mm)',
            filter: 'number',
            width: 100,
            minWidth: 100,
            valueFormatter: (params) => {
                if (params.value) {
                    return (params.data.isWidthDiameter ? 'ø' : '') + params.value + 'mm'
                } else {
                    return '-'
                }
            }
        },
        {
            field: 'heightMillimeters',
            headerName: 'H (mm)',
            filter: 'number',
            width: 100,
            minWidth: 100,
            valueFormatter: (params) => {
                return params.value ? params.value + 'mm' : '-'
            }
        },
        {
            field: 'depthMillimeters',
            headerName: 'D (mm)',
            filter: 'number',
            width: 100,
            minWidth: 100,
            valueFormatter: (params) => {
                return params.value ? params.value + 'mm' : '-'
            }
        },
        {
            field: 'widthInches',
            headerName: 'W (in)',
            filter: 'number',
            width: 90,
            minWidth: 90,
            valueFormatter: (params) => {
                if (params.value) {
                    return (params.data.isWidthDiameter ? 'ø' : '') + params.value + 'in'
                } else {
                    return '-'
                }
            }
        },
        {
            field: 'heightInches',
            headerName: 'H (in)',
            filter: 'number',
            width: 90,
            minWidth: 90,
            valueFormatter: (params) => {
                return params.value ? params.value + 'in' : '-'
            }
        },
        {
            field: 'depthInches',
            headerName: 'D (in)',
            filter: 'number',
            width: 90,
            minWidth: 90,
            valueFormatter: (params) => {
                return params.value ? params.value + 'in' : '-'
            }
        },
        {
            field: 'display',
            headerName: 'Display',
            filter: 'text',
            width: 300,
            minWidth: 105
        }
    ]
  }
  


// WEBPACK FOOTER //
// ./client/modules/Dimensions/gridOptions.js